import { Search } from "@mui/icons-material";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "usehooks-ts";
import ToggleBtnGroup from "../../../components/ToggleBtnGroup/ToggleBtnGroup";
import useSkipFirstRenderEffect from "../../../hooks/use-skip-first-render-effect";
import { OpportunityType } from "../../../types";
import {
  OpportunitiesStatusFilters,
  OpportunitiesStatusFilterText,
} from "../../../utils/coimex-utils";
import { selectSubCategories } from "../../settings/settings.selectors";
import { getOffersAction } from "../offers.effects";
import {
  selectIsGetOffersStatusCountsPending,
  selectOffersSearchFilter,
  selectOffersStatusCounts,
  selectOffersStatusFilter,
  selectOffersSubCategoryIdFilter,
} from "../offers.selectors";

export default function OffersFilters() {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const selectedStatus = useSelector(selectOffersStatusFilter);
  const selectedSubCategoryId = useSelector(selectOffersSubCategoryIdFilter);
  const statusCounts = useSelector(selectOffersStatusCounts);
  const searchValue = useSelector(selectOffersSearchFilter);
  const isGetOffersStatusCountsPending = useSelector(
    selectIsGetOffersStatusCountsPending
  );
  const subCategories = useSelector(selectSubCategories);
  const dispatch = useDispatch();

  useSkipFirstRenderEffect(() => {
    dispatch(getOffersAction({ filters: { search: debouncedSearch } }));
  }, [debouncedSearch]);

  const handleSelectedStatusChange = (status) => {
    dispatch(getOffersAction({ filters: { status } }));
  };

  const handleSelectedSubCategoryIdChange = (subCategoryId) => {
    dispatch(getOffersAction({ filters: { subCategoryId } }));
  };

  return (
    <div className="flex justify-between">
      <ToggleBtnGroup
        items={OpportunitiesStatusFilters.map((status) => ({
          label: `${
            OpportunitiesStatusFilterText(OpportunityType.Offer)[status]
          } 
          (${isGetOffersStatusCountsPending ? "?" : statusCounts[status]})`,
          value: status,
        }))}
        selectedValue={selectedStatus}
        onSelectedValueChanged={handleSelectedStatusChange}
      />

      <div>
        <FormControl sx={{ minWidth: 120, marginRight: 2 }} size="small">
          <InputLabel>Category</InputLabel>
          <Select
            label="Category"
            value={selectedSubCategoryId}
            onChange={(e) => handleSelectedSubCategoryIdChange(e.target.value)}
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {subCategories.map((sub) => (
              <MenuItem key={sub.id} value={sub.id}>
                {sub.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          placeholder="Search(Alt+S)"
          sx={{ width: "180px" }}
          InputProps={{
            className: "search-input",
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            autoComplete: "off",
            accessKey: "s",
          }}
          defaultValue={searchValue}
          variant="outlined"
          size="small"
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    </div>
  );
}
